import styled from 'styled-components';

export const DiscountLabel = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  background: var(--color-discount);
  border-radius: 50%;
  width: 90px;
  height: 90px;
  color: #fff;
  display: flex;
  z-index: 10;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  font-size: var(--font-size-lg);
`;
